export const Config = {
    'url': 'https://gtaxpro.gtbharat.in/',
    'reports': 'https://gtaxpro.gtbharat.in/'
}
